import{a as t}from"./chunk-RAAYCPUM.js";function p(...e){return t(y,e)}function y(e){let r={};for(let[n,o]of Object.entries(e))r[o]=n;return r}export{p as a};
